function toNumberForDisplay(value: number | string): number {
    if (typeof value === 'number') {
        return value
    }
    const n = Number(value)
    if (Number.isNaN(n)) {
        return 0
    }
    return n
}

export function formatCurrency(value: number | string): string {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(toNumberForDisplay(value))
}

export function formatNumber(value: number): string {
    return new Intl.NumberFormat('en-US').format(value)
}

export function formatPercent(value: number): string {
    return `${Math.round(value * 100)}%`
}

export function formatDecimal(value: number, digits = 2): string {
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(value)
}

/** Formats a decimal ratio from the API (e.g. "0.25") as a percent for display. */
export function formatRatioAsPercent(value: string | null | undefined): string {
    if (value == null || value === '') {
        return 'N/A'
    }
    const n = Number(value)
    if (Number.isNaN(n)) {
        return '—'
    }
    return new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
    }).format(n)
}
